import React, {useRef} from 'react';
import {useDispatch} from "react-redux";
import CloseIconComponent from "../CloseIconComponent";
import {authReset} from "../../../store/API/actions";

const SessionIsOutComponent = () => {
    const dispatch = useDispatch();
    const ref = useRef<HTMLDivElement>(null);
    const onclose = () => dispatch(authReset());

    return (
        <div className='warning'
             ref={ref}
        >
            <div className='warning__title'>
                <h2>Network Error</h2>
                <CloseIconComponent handler={onclose}/>
            </div>

            <div className='warning__content'>
                {window.CONFIG.ServerAddress}:{window.CONFIG.ServerPort} server is not responding or cannot be reached
            </div>
        </div>
    );
};

export default SessionIsOutComponent;